// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"LO-z","carouselContainer":"MO-z"};